import BaseBox from "./BaseBox";
import PoweredByGrin from "./PoweredByGrin";

export default {
    install: (Vue) => {
       Vue.component(BaseBox.name, BaseBox);
       Vue.component(PoweredByGrin.name, PoweredByGrin);
    }
}
